import { render, staticRenderFns } from "./MFCDelete.vue?vue&type=template&id=2ecc0724&scoped=true"
import script from "./MFCDelete.vue?vue&type=script&lang=js"
export * from "./MFCDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc0724",
  null
  
)

export default component.exports